import './HomePage.scss';

export const HomePage = () => {
  return (
    <div className="home-page">
      <h1>Welcome :)</h1>
    </div>
  )
};
